module.exports = __webpack_public_path__ + "static/img/ic_hidden_description.0088271b.svg";